import SteamVideos from '@/components/SteamVideos'
import {setI18l} from "@/helpers/veevalidate"
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: SteamVideos,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}
